import React from 'react';
import SiteLayout from '../components/SiteLayout';
import PageHero from '../components/PageHero';
import CtaBand from '../components/CtaBand';
import InfraProjectSlider from '../infrastructure/InfraProjectSlider';
import { useInfraProjects, useCtaInfrastructure, usePageInfrastructure } from '../data';

// §7.3 — Hero → project slider → CTA band.
export default function InfrastructurePage() {
  const page = usePageInfrastructure();
  return (
    <SiteLayout navVariant="page">
      <PageHero accent={page.titleAccent} white={page.titleWhite} accentFirst lead={page.lead} variant="infrastructure" />
      <InfraProjectSlider projects={useInfraProjects()} />
      <CtaBand cta={useCtaInfrastructure()} variant="infrastructure" />
    </SiteLayout>
  );
}
